import { atom } from 'jotai';
import { ResCouponType } from '@src/apis/types/coupon';

export const barcodeAtom = atom<ResCouponType | null>(null);
